module.exports = __webpack_public_path__ + "static/media/ic_religare_logo.b6254457.svg";